import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import "./StockSetProduct.css";
import StockSetProductCard from "components/ui/StockSetProductCard";
import useStockInCatalog from "hooks/useStockInCatalog";
import { useGlobalContext } from "context/GlobalContext";
import { Toast, ProductCard } from "components/ui";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, initCart, removeFromCart } from "store/cartSlice";

const StockSetsProduct = React.memo(({ product, allData }) => {
  const { setBtnTitle, btnTitle, presentInCatalog } = useStockInCatalog(product);
  // const [selectedCartProducts, setSelectedCartProducts] = useState({});
  // const { setCountCart, countCart, addToCart, removeFromCart } = useGlobalContext();
  const [btn, setBtn] = useState("Select");
  const [toastOpen, setToastOpen] = useState(false);
  const location = useLocation();
  const innerChnages = location?.state?.innerChnages;
  const isEdit = location?.state?.edit || innerChnages;

  const dispatch = useDispatch();

  const isInCart = useSelector((state) => {
    const cart = state.cart.cartData;
    return cart.some((item) => item.styleNumber === product.styleNumber);
  });

  const selectedCartProducts = React.useMemo(
    () => ({
      ...product,
      isAddedInCart: true,
    }),
    [product]
  );

  const handleAddToCartBtn = React.useCallback(() => {
    if (innerChnages) {
      dispatch(addToCart({
        product: selectedCartProducts,
        location: location
      }));
    } else {
      dispatch(addToCart({
        product: selectedCartProducts,
        location: location
      }));
    }
  }, [dispatch, selectedCartProducts, innerChnages]);

  const handleRemoveCart = React.useCallback(() => {
    if (innerChnages) {
      dispatch(removeFromCart(selectedCartProducts));
    } else {
      dispatch(removeFromCart(selectedCartProducts));
    }
  }, [dispatch, selectedCartProducts, innerChnages]);

  useEffect(() => {
    dispatch(initCart());
  }, [dispatch]);

  useEffect(() => {
    setBtnTitle(isInCart ? "Added" : "Add");
  }, [isInCart, setBtnTitle]);

  const handleCloseToast = (Reason) => {
    if (Reason === "clickaway") {
      return;
    }
    setToastOpen(false);
  };
  // const handleAddToCartBtn = () => {
  //   setBtnTitle("Added");
  //   addToCart(selectedCartProducts);
  //   window.dispatchEvent(new Event("cartUpdated"));
  // };

  // const handleRemoveCart = () => {
  //   setBtnTitle("Add");
  //   removeFromCart(selectedCartProducts);
  //   sessionStorage.setItem("RecentlyRemoved", JSON.stringify(selectedCartProducts));
  //   window.dispatchEvent(new Event("cartUpdated"));
  // };
  // useEffect(() => {
  //   setSelectedCartProducts(() => ({
  //     ...product,
  //     isAddedInCart: true,
  //   }));
  // }, []);

  return (
    <>
      <Grid item className="stockset">
        <StockSetProductCard
          style={{ maxWidth: isEdit ? "430px" : "430px", minWidth: isEdit ? "430px" : "430px" }}
          data={product}
          selectedCartProducts={selectedCartProducts}
          {...(innerChnages && {
            isBtn: innerChnages,
            addtoCart: handleAddToCartBtn,
            btnTilte: btnTitle,
            removeCart: handleRemoveCart,
            presentInCatalog: presentInCatalog,
          })}
          allData={allData}
        />
        {/* <Toast
          open={toastOpen}
          msg={`Design Has Been Added To Cart ${countCart} `}
          autoHideDuration={2000}
          onClose={handleCloseToast}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          ContentProps={{
            sx: { backgroundColor: "#50C878" },
          }}
        /> */}
      </Grid>
    </>
  );
});

export default React.memo(StockSetsProduct);
